{{((amount ?? 0) * conversionRate) | price: currencyCode: shortenNumber }}
